import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "form-wrapper slide-up"
}
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = { class: "form-close" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onUpdate:modelValue"]
const _hoisted_7 = { style: {"display":"flex","margin-top":"10px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              type: "button",
              class: "form-close-x",
              title: "Close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            }, "×")
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("h3", null, "Name", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.Name) = $event))
          }, null, 512), [
            [_vModelText, _ctx.formData.Name]
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("h3", null, "Columns", -1)),
          _createVNode(_component_draggable, {
            list: _ctx.formData.ColumnsJSON
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.ColumnsJSON, (col, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "link-item"
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    (_openBlock(), _createElementBlock("svg", {
                      onClick: ($event: any) => (_ctx.removeCol(i)),
                      style: {"color":"red","width":"18px","height":"18px"},
                      fill: "currentColor",
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "18",
                      height: "18",
                      viewBox: "0 0 24 24"
                    }, [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("path", { d: "M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 16.538l-4.592-4.548 4.546-4.587-1.416-1.403-4.545 4.589-4.588-4.543-1.405 1.405 4.593 4.552-4.547 4.592 1.405 1.405 4.555-4.596 4.591 4.55 1.403-1.416z" }, null, -1)
                    ]))], 8, _hoisted_5))
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    style: {"margin":"0 0 5px"},
                    type: "text",
                    "onUpdate:modelValue": ($event: any) => ((col.name) = $event),
                    placeholder: "Column Name"
                  }, null, 8, _hoisted_6), [
                    [_vModelText, col.name]
                  ])
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["list"]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addCol())),
              class: "btn",
              style: {"margin":"0"}
            }, "Add Column")
          ]),
          _createElementVNode("input", {
            style: {"margin-top":"25px"},
            class: _normalizeClass(_ctx.disableButton ? 'disable-button' : ''),
            type: "submit",
            value: "Submit",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submit()))
          }, null, 2)
        ]))
      : _createCommentVNode("", true)
  ]))
}